<template>
    <div>
        <h4>Перегрузить Каталог товаров из Excel</h4>

        <ProgressBar mode="indeterminate" style="height: .5em" v-if="progressCatalogFiles" />
        <br>
        <div class="buttons-group">
            <p-fileupload
                mode="basic"
                name="source"
                class="button-krm-primary"
                :url="route('api.vector.upload-catalog-files-products')"
                accept="application/*"
                @upload="onUploadCatalogFiles"
                @error="onErrorCatalogFiles"
                @before-upload="beforeUploadCatalogFiles"
            ></p-fileupload>

            <Button
                label="Очистить Бренды"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_brands')"
            />
            <Button
                label="Очистить Направления"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_directions')"
            />
            <Button
                label="Очистить Группы"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_direction_groups')"
            />
            <Button
                label="Очистить Подгруппы"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_direction_sub_groups')"
            />
            <Button
                label="Очистить Серии"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_direction_sub_group_parts')"
            />
            <Button
                label="Очистить Товары"
                icon="pi pi-trash"
                class="but btn-danger"
                @click="clearTable('catalog_products')"
            />
        </div>

        <DataTable :value="files">
            <Column header="Файл">
                <template #body="slotProps">
                    <p :class="{'text-success': slotProps.data.is_uploaded}">{{ slotProps.data.title }}</p>
                </template>
            </Column>
            <Column header="Статус">
                <template #body="slotProps">
                    <p :class="{'text-success': slotProps.data.is_uploaded}"><b v-if="slotProps.data.is_uploaded">(Завантажено)</b> </p>
                </template>
            </Column>
            <Column header="Дата">
                <template #body="slotProps">
                    <p :class="{'text-success': slotProps.data.is_uploaded}">{{ moment(slotProps.data.created_at).format("h:mm:ss DD-MM-YYYY") }}</p>
                </template>
            </Column>
            <Column header="Пользователь">
                <template #body="slotProps">
                    <p v-if="slotProps.data.user">{{ slotProps.data.user.email }}</p>
                </template>
            </Column>
            
            <Column header="">
                <template #body="slotProps">
                    <div class="list_file_container">
                        <Button
                            label="Загрузить"
                            icon="pi pi-plus"
                            class="button-krm-primary"
                            @click="selectFileToUpload(slotProps.index)"
                        />
                        <a :href="slotProps.data.file" target="_blank">
                            <Button
                                label="Скачать"
                                icon="pi pi-download"
                                class="button-krm-primary"
                            />
                        </a>
                        <Button
                            label="Удалить"
                            icon="pi pi-minus"
                            class="button-krm-primary"
                            @click="deleteFile(slotProps.index)"
                        />
                    </div>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Button from "primevue/button";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import swal from 'sweetalert2';

export default {
    layout: AppLayout,
    props: {
        files: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            progressCatalogFiles: false,
            moment: moment,
        }
    },
    components: {
        ProgressBar,
        "p-fileupload": FileUpload,
        "p-toast": Toast,
        Input,
        Button,
        DataTable,
        Column,
        swal,
    },
    methods: {
        onUploadCatalogFiles() {
            this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
            this.progressCatalogFiles = false;
            location.reload();
        },
        beforeUploadCatalogFiles() {
            this.progressCatalogFiles = true;
        },
        onErrorCatalogFiles(event) {
            let errorMessage = 'Upload Error';
            try {
                let jsonResponse = JSON.parse(event.xhr.response);
                errorMessage = jsonResponse.message
            } catch (error) {
            }

            this.$toast.add({severity: 'error', summary: 'Error', detail: errorMessage, life: 3000});
            this.progressCatalogFiles = false;
        },

        selectFileToUpload(index) {
            let id = this.files[index].id
            this.progressCatalogFiles = true
            axios.post(this.route('api.vector.upload-catalog-files-products.upload', {id: id}))
                .then((result) => {
                    this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
                    this.progressCatalogFiles = false
                    location.reload();
                }).catch((error) => {
                    this.$toast.add({severity: 'error', summary: 'Error', detail: 'Upload Error', life: 3000});
                    this.progressCatalogFiles = false
                    window.scroll(0, 0);
                })
        },

        deleteFile(index) {
            let id = this.files[index].id
            this.progressCatalogFiles = true
            axios.post(this.route('api.vector.upload-catalog-files-products.delete', {id: id}))
                .then((result) => {
                    this.$toast.add({severity: 'info', summary: 'Success', detail: 'File deleted!', life: 3000});
                    this.progressCatalogFiles = false
                    location.reload();
                }).catch((error) => {
                    this.$toast.add({severity: 'error', summary: 'Error', detail: 'Delete Error', life: 3000});
                    this.progressCatalogFiles = false
                    window.scroll(0, 0);
                })
        },

        clearTable(table) {
            new swal({
                title: 'Ви впевнені?',
                text: 'Таблиця ' + table + ' буде повністю очищена!',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                this.progressCatalogFiles = true
                axios.post(this.route('api.vector.upload-catalog-clear-table.delete', {table: table}))
                    .then((result) => {
                        this.$toast.add({severity: 'info', summary: 'Success', detail: 'Table cleared!', life: 3000});
                        this.progressCatalogFiles = false
                        location.reload();
                    }).catch((error) => {
                        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Clear table Error', life: 3000});
                        this.progressCatalogFiles = false
                        window.scroll(0, 0);
                    })

            });
        },
    }
};
</script>

<style scoped>
.buttons-group {
    display: flex;
    gap: 10px;
    margin-bottom: 1rem;
}
.list_files {
    height: 400px;
    width: 100%;
    border: 1px solid #356EEF;
    margin-top: 20px;
}
.list_file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 10px;
    border-top: 1px solid #356EEF;
    border-bottom: 1px solid #356EEF;
    cursor: pointer;
}
.list_file_container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: 20px;
}
.list_file:hover {
    background-color: lightgray;
}
.list_file p {
    margin: 0;
}
.text-success {
    color: darkgreen;
}
</style>
